/**
 * @file commands.js
 * @desc This module contains Commands framework definition.
 * @author Igor Kling <kling.igor.ksi@gmail.com>
 * @version 1.0.dev
 * @copyright 2016 (c) KSI Corporation
 * */

(/** @lends <global> */function (global) {
    'use strict';
    
    /**
     * Constructs Queue of commands.
     * @class
     * @constructor
     * @name Queue
     * @classdesc Queue stores commands which run sequentially.
     * */
    var Queue = function(){
        this.commands = [];
        
        this.completeCommandIndex = null;
        this.runningCommandIndex = null;

        this.jumpCommandIndex = null;
    };
    
    Queue.prototype.constructor = Queue;
    
    /**
     * Clear queue.
     * @memberOf Queue
     * */
    Queue.prototype.clear = function() {
        
        if (this.runningCommandIndex !== undefined && this.runningCommandIndex < this.commands.length) {
            var command = this.commands[this.runningCommandIndex];
            if (command && command.stop) {
                command.stop();
            }
        }
        
        this.commands = [];
        this.completeCommandIndex = null;
        this.runningCommandIndex = null;
    };
    
    /**
     * Forward commands execution.
     * @param {Number} dt time gap since last call to forward execution on.
     * @memberOf Queue
     * */
    Queue.prototype.forward = function(dt) {
        
        if (this.commands.length === 0) return;


        if (this.jumpCommandIndex !== null) {
            this.runningCommandIndex = this.jumpCommandIndex === 0 ? null : this.jumpCommandIndex - 1;
            this.completeCommandIndex = this.jumpCommandIndex === 0 ? null : this.jumpCommandIndex - 1;
        }
        this.jumpCommandIndex = null;


        // частный случай когда в очереди еще ниодна команда не старотовала
        if (this.runningCommandIndex === null && this.completeCommandIndex === null) {

            this.runningCommandIndex = 0;
            this.commands[this.runningCommandIndex].start();
            
            if (this.runningCommandIndex === this.completeCommandIndex) {
                this.forward(dt);
            }
        }
        
        if (this.runningCommandIndex == this.completeCommandIndex &&
            this.runningCommandIndex < this.commands.length - 1) {

            this.runningCommandIndex++;

            // может закончиться мгновенно
            this.commands[this.runningCommandIndex].start();

            // если команда выполнилась (в т.ч. могла быть и очистка)
            if (this.runningCommandIndex != null && this.runningCommandIndex === this.completeCommandIndex) {
                this.forward(dt);
            }
        }
    };
    
    Queue.prototype.goTo = function (commandId) {
        if (this.commands.length === 0) return;
        if (commandId >= this.commands.length) {
            console.error("Trying to go out of command queue... ");
            return;
        }

        this.jumpCommandIndex = commandId;
    };
    
    
    Object.defineProperties(Queue.prototype, {
        isComplete:{
            enumerable: true,
            configurable: false,
            get: function () {
                if (this.commands.length === 0) return true;
                return (this.commandIndex != null && this.commandIndex >= this.commands.length);
            }
        }
    });
    
    /**
     * Add new commands to queue.
     * @param {Object} command Command to add.
     * @memberOf Queue
     * */
    Queue.prototype.addCommand = function(command){
        
        // get rid of making function (Call, MoveTo, etc)
        var args = [].splice.call(arguments, 1);
        
        // making command
        var cmd = command.apply(null, args);
        
        cmd.onComplete(function(tween){

            if (tween) {
                TWEEN.Tween.remove(tween);
            }


            if (this.completeCommandIndex == null) {
                this.completeCommandIndex = 0;
            }
            else {
                this.completeCommandIndex++;
            }
            
            // // запускаем следующую команду
            // if (this.commandIndex < this.commands.length) {
            //
            // 	console.log("START COMMAND AT:" + this.commandIndex);
            // 	this.commands[this.commandIndex].start();
            // }
            
        }.bind(this));
        
        this.commands.push(cmd);
    };
    
    /**
     * All objects which run commands should be a SmartObject
     * */
    var SmartObject = {
        _queues: {},
        
        mixin: function(object) {
            for (var k in this) {
                if (k !== 'mixin' && this.hasOwnProperty(k) && !object.hasOwnProperty(k)) {
                    if (k === '_queues') {
                        object[k] = {};
                    }
                    else {
                        object[k] = this[k];
                    }
                }
            }
            return object;
        },
        
        queue: function (id) {
            if (this._queues[id] === undefined) {
                this._queues[id] = new Queue();
            }
            
            return this._queues[id];
        },
        
        addCommand: function (queueId, command) {
            var args = [].splice.call(arguments, 1);
            args[0] = args[0].bind(this);
            this.queue(queueId).addCommand.apply(this.queue(queueId), args);
        },
        
        updateCommands: function(dt) {
            for (var id in this._queues) {
                this._queues[id].forward(dt);
            }
        },
        
        clear: function (queueId) {
            if (queueId === undefined) {
                for (var k in this._queues) {
                    this._queues[k].clear();
                }
            }
            else {
                if (this._queues[queueId]) {
                    this._queues[queueId].clear();
                }
            }
        }
    };


// command constructing functions
    var Commands = {
        
        
        MoveTo: function (position, time, easing) {

            var tween = new TWEEN.Tween(this.position).to(position, time);
            
            // for example: TWEEN.Easing.Sinusoidal.Out
            if (easing) {
                tween.easing(easing);
            }
            
            return tween;
        },
        
        Scale: function (scale, time, easing) {
            
            var tween = null;
            
            if (typeof scale === 'number') {
                tween = new TWEEN.Tween(this.scale).to({x:scale, y:scale}, time);
            }
            else {
                tween = new TWEEN.Tween(this.scale).to(scale, time);
            }
            
            if (easing) {
                tween.easing(easing);
            }
            
            return tween;
        },
        
        FlipHorizontally: function () {

            var self = this;

            return {
                start: function() {
                    self.scale.x = -self.scale.x;
                    this.done();
                },
                onComplete: function(done) {
                    this.done = done;
                },
                done: null
            };
        },
    
        FlipVertically: function () {

            var self = this;

            return {
                start: function() {
                    self.scale.y = -self.scale.y;
                    this.done();
                },
                onComplete: function(done) {
                    this.done = done;
                },
                done: null
            };
        },
        
        GoTo: function (queueId, commandId) {

            var queue = this.queue(queueId);

            return {
                start: function() {
                    if (queue) {
                        queue.goTo(commandId);
                    }

                    this.done();
                },
                onComplete: function(done) {
                    this.done = done;
                },
                done: null
            };
        },
        
        Clear: function (queue) {
            return {
                start: function() {
                    queue.clear();
                    this.done();
                },
                onComplete: function(done) {
                    this.done = done;
                },
                done: null
            };
        },
        
        Call: function(func) {
            
            var args = [].splice.call(arguments, 1);
            
            return {
                start: function() {
                    func.apply(null, args);
                    
                    this.done();
                },
                onComplete: function(done) {
                    this.done = done;
                },
                done: null
            };
        },
        
        Wait: function(from, to) {
            return {
                start: function() {
                    var time = (to === undefined) ? from : Math.floor(Math.random() * (to - from + 1)) + from;

                    // console.log("rand time = " + time);

                    this.timerId = setTimeout(function(){
                        this.done();
                    }.bind(this), time);
                },
                onComplete: function(done) {
                    this.done = done;
                },
                stop: function () {
                    clearTimeout(this.timerId);
                },
                done: null,
                timerId: null
            };
        },

        InfiniteRotate: function (time) {
            return new TWEEN.Tween(this)
                .to({rotation: '-' + Math.PI / 2}, time)
                .onComplete(function() {
                    // Check that the full 360 degrees of rotation,
                    // and calculate the remainder of the division to avoid overflow.
                    if (Math.abs(this.rotation) >= 2 * Math.PI) {
                        this.rotation = this.rotation % (2 * Math.PI);
                    }
                }.bind(this))
                .repeat(Infinity);
        },
        
        // requires Animation class (modified PIXI.MovieClip)
        Animate: function (animation, from, to) {
            return {
                start: function () {
                    animation.onComplete = function () {
                        this.done();
                    }.bind(this);
                    animation.gotoAndPlay(from, to);
                },
                onComplete: function (done) {
                    this.done = done;
                },
                done: null
            };
        },

        //rotation by angle degrees
        Rotate: function (angle, time, easing) {

            var angleRadian = angle * (Math.PI / 180);

            var tween = new TWEEN.Tween(this).to({rotation : angleRadian}, time);

            // for example: TWEEN.Easing.Sinusoidal.Out
            if (easing) {
                tween.easing(easing);
            }

            return tween;
        },

        MoveByX: function (coordX, time, easing) {

            var tween = new TWEEN.Tween(this).to({x : coordX}, time);

            // for example: TWEEN.Easing.Sinusoidal.Out
            if (easing) {
                tween.easing(easing);
            }

            return tween;
        },

        MoveByY: function (coordY, time, easing) {

            var tween = new TWEEN.Tween(this).to({y : coordY}, time);

            // for example: TWEEN.Easing.Sinusoidal.Out
            if (easing) {
                tween.easing(easing);
            }

            return tween;
        }
    };

    
    global.SmartObject = SmartObject;
    global.Commands = Commands;
}(typeof module === 'object' && module.exports || this));


//////////////////
// WEBPACK FOOTER
// ./src/library/commands.js
// module id = 29
// module chunks = 0